import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { changeCursorTo, CursorTypes } from '../../utils/changeCursor';
import {
  hideImportBeginningBalancesModal,
  importBeginningBalancesFile,
} from './store/actions';
import Modal from '../../shared/modals/modal.component';
import { isUploadingBeginningBalancesSelector } from './store/selectors';
import { renderImportInstructions } from './importFileFormatRules';
import { requiredWhenPresent } from '../../shared/propTypes';


class ImportBeginningBalancesModal extends PureComponent {
  static propTypes = {
    hideImportBeginningBalancesModal: PropTypes.func.isRequired,
    importBeginningBalancesFile: PropTypes.func.isRequired,
    companyCode: requiredWhenPresent(['isVisible'], PropTypes.string),
    isUploadingBeginningBalances: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
  };

  componentDidUpdate(prevProps) {
    const isUploadingBeginningBalancesChanged = (
      prevProps.isUploadingBeginningBalances !== this.props.isUploadingBeginningBalances
    );

    if (isUploadingBeginningBalancesChanged && prevProps.isUploadingBeginningBalances) {
      changeCursorTo(CursorTypes.DEFAULT);
      this.props.hideImportBeginningBalancesModal();
    }
  }

  importBeginningBalancesFile = event => {
    const file = event.target.files[0];
    this.props.importBeginningBalancesFile({
      file,
    });
    event.target.value = '';
    changeCursorTo(CursorTypes.WAIT);
  };

  render() {
    const {
      companyCode,

      hideImportBeginningBalancesModal,
      isUploadingBeginningBalances,
      isVisible,
    } = this.props;

    return (
      <Modal
        className="import-beginning-balances-modal"
        title="Import Beginning Balances"
        closeAction={hideImportBeginningBalancesModal}
        dismissText="Cancel"
        dismissAction={hideImportBeginningBalancesModal}
        submitText="Select File to Import"
        submitAction={this.importBeginningBalancesFile}
        isVisible={isVisible}
        isSubmitting={isUploadingBeginningBalances}
        withUpload
      >
        <div>
          Tax Provision: {companyCode}<br /><br />
          Import file must have the following Excel format:<br />
          {renderImportInstructions()}
          Warning: All current Beginning Balance rows will be removed and replaced with the imported values.
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    isUploadingBeginningBalances: isUploadingBeginningBalancesSelector(state),
  };
}

export default connect(
  mapStateToProps,
  {
    hideImportBeginningBalancesModal,
    importBeginningBalancesFile,
  }
)(ImportBeginningBalancesModal);
